import styled from 'styled-components';

export const PointExpirePopupWidgetStyled = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  z-index: 99;
  padding: 16px;
  box-sizing: border-box;
  /* จอเตี้ย (LINE บน iPhone SE) ให้เลื่อนการ์ดได้ ไม่ให้ปุ่มปิดหลุดจอ */
  overflow-y: auto;
  .popup_bg {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100vw;
    height: 100vh;
    background: ${({ theme }) => theme.COLORS.BLACK_1}66;
  }
  .popup_card {
    position: relative;
    z-index: 2;
    border-radius: 20px;
    width: 100%;
    max-width: 354px;
    padding: 30px 16px 19px 16px;
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    box-sizing: border-box;
    max-height: calc(100vh - 32px);
    overflow-y: auto;
    margin: auto 0;
    .popup_close {
      position: absolute;
      top: 12px;
      right: 12px;
      cursor: pointer;
    }
    .pe_logo_wrap {
      width: 139px;
      margin: auto;
      .pe_logo {
        width: 100%;
        height: auto;
      }
    }
    .pe_warning_bar {
      margin: 16px auto 10px auto;
      width: 100%;
      height: 6px;
      border-radius: 6px;
      background: ${({ theme }) => theme.COLORS.ORANGE_1};
      position: relative;
      .pe_warning_icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        justify-content: center;
        align-items: center;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        border: 4px solid ${({ theme }) => theme.COLORS.WHITE_1};
        background: ${({ theme }) => theme.COLORS.ORANGE_1};
        color: ${({ theme }) => theme.COLORS.WHITE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S22};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_BOLD};
        line-height: 1;
      }
    }
    .pe_title {
      margin-top: 22px;
      margin-bottom: 8px;
      color: ${({ theme }) => theme.COLORS.BLUE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S18};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
    }
    .pe_desc {
      margin-bottom: 16px;
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
      line-height: 1.5;
    }
    .pe_highlight {
      margin-bottom: 20px;
      padding: 12px 10px;
      border-radius: 12px;
      border: 1px solid ${({ theme }) => theme.COLORS.ORANGE_2};
      background: ${({ theme }) => theme.COLORS.ORANGE_2}26;
      .pe_highlight_label {
        color: ${({ theme }) => theme.COLORS.GRAY_2};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
      }
      .pe_highlight_point {
        display: flex;
        justify-content: center;
        align-items: baseline;
        gap: 6px;
        .pe_point_number {
          color: ${({ theme }) => theme.COLORS.BLUE_1};
          font-size: ${({ theme }) => theme.FONT.SIZE.S32};
          font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_BOLD};
          line-height: 1.2;
        }
        .pe_point_unit {
          color: ${({ theme }) => theme.COLORS.BLUE_1};
          font-size: ${({ theme }) => theme.FONT.SIZE.S18};
          font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
        }
      }
      .pe_highlight_days {
        color: ${({ theme }) => theme.COLORS.RED_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
      }
    }
    .pe_btn_wrap {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin: auto;
      max-width: 220px;
      .pe_btn_item {
        width: 100%;
      }
    }
  }
`;
